import { useEffect, useState } from "react";
import { Box, Container, Divider, Link, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import { Link as ReactLink } from "react-router-dom";
import { useCmsApi } from "../../services/useCmsApi";

const mainLinks = [
	{ label: "Home", to: "/" },
	{ label: "See It In Use", to: "/example-farms" },
	{ label: "News & Media", to: "/news" },
	{ label: "About Us", to: "/about-us" },
	{ label: "Contact Us", to: "/contact-us" },
];

export const Footer = () => {
	const cmsApi = useCmsApi();
	const [contactEmail, setContactEmail] = useState("info@geco-ag.com");
	const [contactPhone, setContactPhone] = useState("+1 604 809 0430");

	useEffect(() => {
		let cancelled = false;
		cmsApi.getSiteSettings().then((settings) => {
			if (cancelled) return;
			for (const s of settings) {
				if (s.key === "contactEmail") setContactEmail(s.value);
				if (s.key === "contactPhone") setContactPhone(s.value);
			}
		});
		return () => { cancelled = true; };
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Box bg="gray.50" borderTop="1px solid" borderColor="gray.200">
			<Container as="footer" role="contentinfo" py={{ base: "10", md: "12" }} maxW="1480px">
				<SimpleGrid columns={{ base: 1, sm: 2, md: 2 }} spacing="8" mb="8">
					<Stack spacing="3">
						<Text fontWeight="bold" fontSize="sm" color="gray.700" textTransform="uppercase" letterSpacing="wide">
							Navigate
						</Text>
						{mainLinks.map((link) => (
							<Link key={link.to} as={ReactLink} to={link.to} color="gray.600" fontSize="sm" _hover={{ color: "green.700" }}>
								{link.label}
							</Link>
						))}
					</Stack>
					<Stack spacing="3">
						<Text fontWeight="bold" fontSize="sm" color="gray.700" textTransform="uppercase" letterSpacing="wide">
							Contact
						</Text>
						<Link href={`mailto:${contactEmail}`} color="gray.600" fontSize="sm" _hover={{ color: "green.700" }}>
							{contactEmail}
						</Link>
						<Link href={`tel:${contactPhone.replace(/\s/g, "")}`} color="gray.600" fontSize="sm" _hover={{ color: "green.700" }}>
							{contactPhone}
						</Link>
					</Stack>
				</SimpleGrid>
				<Divider borderColor="gray.200" />
				<Text pt="6" fontSize="sm" color="gray.500" textAlign={{ base: "center", md: "left" }}>
					&copy; {new Date().getFullYear()} Geco Strategic Weed Management. All rights reserved.
				</Text>
			</Container>
		</Box>
	);
};
